import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=7ca2ff35"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeSlider: require('/vercel/path0/components/shared/home/HomeSlider.vue').default,ComponentLoader: require('/vercel/path0/components/ComponentLoader.vue').default})
